var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "178.3px",
    height: "35.3px",
    viewBox: "0 0 178.3 35.3",
    enableBackground: "new 0 0 178.3 35.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6D6E70",
    points: "103.5,3.4 74.8,3.4 70.5,10.7 82.3,10.7 82.3,31.1    90.6,31.1 90.6,10.7 99.2,10.7 103.5,3.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#6D6E70",
    points: "116.1,2 99.3,31.1 107.6,31.1 116.1,16.4 120.7,24.2 114,24.2 110.1,31.1 133,31.1 116.1,2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6D6E70",
    points: "8,3.4 30.7,3.4 17.2,24.4 32.1,24.4 28.3,31.1 3.6,31.1    17.3,10.1 4.1,10.1 8,3.4  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFD300",
    d: "M51.5,24.9c-3.7,0-6.6-3.4-6.6-7.5s2.9-7.4,6.6-7.4   c3.7,0,6.7,3.3,6.7,7.4S55.2,24.9,51.5,24.9 M51.5,2.9c-8.3,0-14.9,6.4-14.9,14.4c0,8.1,6.7,14.5,14.9,14.5   c8.3,0,14.9-6.5,14.9-14.5C66.5,9.3,59.8,2.9,51.5,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E70",
    d: "M149.7,24.4c-3.7,0-6.1-3.2-6.1-7.1c0-3.9,2.7-7,6.1-7h10.6l4.2-7.4h-15.8c-5.1,0-9.5,3-11.8,7.4   c-1.1,2.1-1.7,4.5-1.7,7c0,3.4,1.1,6.5,2.9,9c2.5,3.3,6.3,5.5,10.6,5.5h12.1l4.2-7.4H149.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E70",
    d: "M173.1,5.3L173.1,5.3c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.3-1-0.3h-1.5v3.3h0.6V6.4h0.7l0.8,1.2h0.7   l-0.9-1.3C172.8,6.2,173.1,5.8,173.1,5.3 M171,5.9V4.8h0.9c0.4,0,0.7,0.2,0.7,0.6v0c0,0.3-0.3,0.6-0.7,0.6H171z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E70",
    d: "M171.7,2.9c-1.7,0-3.1,1.4-3.1,3.1S170,9,171.7,9c1.7,0,3.1-1.4,3.1-3.1S173.4,2.9,171.7,2.9 M171.7,8.5   c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6c1.4,0,2.6,1.1,2.6,2.6C174.2,7.4,173.1,8.5,171.7,8.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZLogo);
export default __webpack_public_path__ + "static/media/z_logo.1b9015950041847c7de3e2fa415837be.svg";
export { ForwardRef as ReactComponent };